// src/api/questionnaireQuestions.js

import { get, post, patch, destroy } from "@/lib/fetcher";

const basePath = "/admin/candidate_questionnaire_responses";

// export async function getQuestions() {
//     return await get(basePath);
// }
//
// export async function postQuestion(data) {
//     return await post(basePath, data);
// }
//
export async function patchCandidateQuestionnaireResponses(id, data) {
    return await patch('/admin/candidate_questionnaire_responses', 'update_all', {candidate_slug:id, ...data});
}
//
// export async function deleteQuestion(id) {
//     return await destroy(`${basePath}/${id}`);
// }
//
// export async function patchQuestionOrder(data) {
//     return await patch("/admin/questionnaire_questions/reorder", null, { questions: data });
// }
